//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSystemInnerList } from '@/api/message';
export default {
  props: {
    ifVirtualEdit: {
      type: Boolean,
      default: false
    },
    AddformData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    editordate: null
  },
  data: function data() {
    return {
      formPower: {
        dictGroupCode: null,
        dictGroupName: null,
        systemId: null
      },
      formPowerdefault: {
        dictGroupCode: null,
        dictGroupName: null,
        systemId: null
      },
      selectarr: [],
      systemlist: [],
      dictarr: [],
      roleRules: {
        dictGroupName: [{
          required: true,
          message: '请输入键值对组名称',
          trigger: 'blur'
        }],
        dictGroupCode: [{
          required: true,
          message: '请输入键值对组键值',
          trigger: 'blur'
        }]
        // systemId: [
        //     { required: true, message: '请选择子系统', trigger: 'blur' }
        //   ],
        // relations: [
        //     { required: true, message: '请选择键值对组', trigger: 'blur' }
        //   ],
      }
    };
  },
  created: function created() {
    if (this.ifVirtualEdit) {
      this.formPower = this.editordate;
    } else {
      this.formPower = this.formPowerdefault;
    }
    this.getsystemlist();
  },
  methods: {
    cancelDailog: function cancelDailog() {
      this.$emit('DictgroupeditorSubmit', {
        bool: false
      });
    },
    getsystemlist: function getsystemlist() {
      var _this = this;
      getSystemInnerList().then(function (res) {
        var code = res.code,
          result = res.result;
        if (code === '0000000000') {
          _this.$nextTick(function () {
            _this.systemlist = result.records;
          });
        }
      });
    },
    getDictAndVirtualGroup: function getDictAndVirtualGroup() {
      var _this2 = this;
      this.$API.getRequest({
        url: "/platform/dict/searchDictAndVirtualGroup/".concat(this.selectarr)
      }).then(function (res) {
        _this2.dictarr = res.result[1].value;
      });
    },
    commit: function commit() {
      var _this3 = this;
      this.$refs.formPower.validate(function (valid) {
        if (valid) {
          _this3.$emit('DictgroupeditorSubmit', {
            bool: true,
            formData: _this3.formPower
          });
        } else {
          _this3.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
    },
    selectchangelist: function selectchangelist() {
      this.getDictAndVirtualGroup();
    },
    selectchange: function selectchange() {
      // console.log(value,"asasds");
    },
    confirmsure: function confirmsure(bool) {
      if (bool) {
        this.commit();
      }
    }
  }
  //  watch: {
  //     list: {
  //       handler(newVal, oldVal) {
  //         this.list.filter(item => {
  //             this.formPower.relations.push(item.realGroupId);
  //         })
  //       },
  //     },
  //   },
};